import * as React from 'react';
import { AppTabs } from '../../components';
import {
  VehicleTypesTab,
  UsersTab,
  UserTypesTab,
  ZonesTab,
  SettingsTab,
  LocalitiesTab,
} from './components';
import { LocationsView } from '../Locations';
import { JobTypesView } from '../JobTypes';
import { ShopsView } from '../Shops';

interface Props {}

export enum SettingTabList {
  VEHICLE_TYPES = 'vehicle-types',
  USERS = 'users',
  USER_TYPES = 'user-types',
  ZONES = 'zones',
  SETTINGS = 'settings',
  LOCALITIES = 'localities',
  LOCATIONS = 'locations',
  JOB_TYPES = 'job-types',
  SHOPS = 'shops',
}

export const Settings: React.FC<Props> = () => {
  const tabs = [
    { label: 'Vehicle Types', value: SettingTabList.VEHICLE_TYPES },
    { label: 'Users', value: SettingTabList.USERS },
    { label: 'User Types', value: SettingTabList.USER_TYPES },
    { label: 'Zones', value: SettingTabList.ZONES },
    { label: 'Settings', value: SettingTabList.SETTINGS },
    { label: 'Localities', value: SettingTabList.LOCALITIES },
    { label: 'Locations', value: SettingTabList.LOCATIONS },
    { label: 'Job Types', value: SettingTabList.JOB_TYPES },
    { label: 'Shops', value: SettingTabList.SHOPS },
  ];

  return (
    <AppTabs tabs={tabs}>
      {(activeTab) => {
        switch (activeTab) {
          case SettingTabList.VEHICLE_TYPES:
            return <VehicleTypesTab />;
          case SettingTabList.USERS:
            return <UsersTab />;
          case SettingTabList.USER_TYPES:
            return <UserTypesTab />;
          case SettingTabList.ZONES:
            return <ZonesTab />;
          case SettingTabList.SETTINGS:
            return <SettingsTab />;
          case SettingTabList.LOCALITIES:
            return <LocalitiesTab />;
          case SettingTabList.LOCATIONS:
            return <LocationsView />;
          case SettingTabList.JOB_TYPES:
            return <JobTypesView />;
          case SettingTabList.SHOPS:
            return <ShopsView />;
          default:
        }
      }}
    </AppTabs>
  );
};
